const inputDE = {
  // PERSONAL INFORMATION
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',

  // CURRENT RESIDENTIAL ADDRESS
  streetNo: '',
  streetAddress: '',
  city: '',
  state: '',
  postCode: '',

  // CONTACT DETAILS
  phoneNo: '',
  emailAddress: '',

  // REFERENCE
  reportingReference: '',
};

export default inputDE;
